<template>
  <div class="w-100 w-40-l flex flex-column items-center ma2 b--near-white">
    <span class="ttl bg-near-white db f3 fw3 w-100 tc mb2">{{ header }}</span>
    <div class="w-100 flex justify-center">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  props: ['header']
}
</script>

<style lang="scss" scoped>
</style>
